import { axiosPublic } from '../config/index';

const useAxiosPublic = () => {
    return axiosPublic;
}

export default useAxiosPublic;